module.exports = __webpack_public_path__ + "img/guizhouHints_19.3103125c.jpg";